import { render, staticRenderFns } from "./EditTaskDialog.vue?vue&type=template&id=494761ae&scoped=true"
import script from "./EditTaskDialog.vue?vue&type=script&lang=ts"
export * from "./EditTaskDialog.vue?vue&type=script&lang=ts"
import style0 from "./EditTaskDialog.vue?vue&type=style&index=0&id=494761ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494761ae",
  null
  
)

export default component.exports